<template>
  <div id="AddressBook" class="container address-book-list-component ablc">
    <div class="row">
      <div class="col-lg-3 col-sm-12">
        <MyAccount />
      </div>
      <div class="col-lg-9 col-sm-12">
        <b-row>
          <b-col>
            <h1>{{ getContentItem("addressBookMenu") }}</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="9">
            <p>{{ getContentItem("addressBookSubTitle") }}</p>
          </b-col>
          <b-col md="3">
            <DnFunctionButton
              :text="getContentItem('newCustomer')"
              :button-id="'newCustomerButton'"
              :callback-fn="addAddress"
              :size="largeSize"
            />
          </b-col>
        </b-row>
        <br/>
        <b-tabs v-if="!showModal">
          <b-tab :title="getContentItem('customerAddresses')" active>
            <b-row>
              <b-col md="6">
                <b-form-group :label-cols="3" :label="getContentItem('perPage')">
                  <b-form-select
                    v-model="pagination.perPage"
                    size="sm"
                    :options="pagination.perPageList"
                    class="customerPerPageFilter"
                    @change="paginationReset"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group :label-cols="3" :label="getContentItem('filter')">
                  <b-form-input
                    v-model="customerFilter"
                    size="sm"
                    :placeholder="getContentItem('search')"
                    @keyup.native="ApplyFilter"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-container v-show="showDeletePrompt" id="deletePrompt">
                  <b-alert show variant="danger">
                    Are you sure you want to <strong>delete {{this.CustomerAddressToDelete.CustomerName}}</strong> from your address book?
                    <b-button @click="deleteAddress(CustomerAddressToDelete.CustomerId)">Yes</b-button>
                    <b-btn @click="showDeletePrompt = !showDeletePrompt">No</b-btn>
                  </b-alert>                  
                </b-container>
                <b-table
                  id="customerAddressTable"
                  ref="customerAddressTableRef"
                  hover
                  striped
                  :no-sort-reset="false"
                  :items="getCustomers"
                  :fields="addressBookColumns"
                  :current-page="pagination.currentPage"
                  :per-page="pagination.perPage"
                  stacked="md"
                  :no-provider-filtering="true"
                  show-empty
                  :no-local-sorting="true"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="blue"
                  :empty-text="getContentItem('noAddressBookEntries')"
                  @sort-changed="paginationReset"
                >
                  <template slot="CustomerName" slot-scope="row">
                    <a :href="`#`" @click="editAddress(row.item)">
                      {{ row.item.CustomerName }}
                    </a>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <b-button-close class="close" @click.stop="prepDelete(row.item)" />
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col id="paginationDisplay" md="6" class="pull-left">
                {{ format(getContentItem("showingPagination"), paginationFirstRecord, paginationLastRecord,
                          pagination.totalRows) }}
              </b-col>
              <b-col md="6">
                <b-pagination
                  v-model="pagination.currentPage"
                  class="pull-right"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.perPage"
                />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="getContentItem('emergencyShipToOverride')">
            <EmergencyShipToOverride />
          </b-tab>
        </b-tabs>
        <CustomerAddressModal
          v-if="showModal"
          :customer-address-dto-prop="CustomerAddressToEdit"
          :selected-country-prop="getCountryLabel(CustomerAddressToEdit.Country)"
          :title="customerAddressModalTitle"
          @close="showModal = false"
          @save="saveAddress"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import MyAccount from "@/components/SubMenus/MyAccount"
  import { AddressBookService } from "@/services/AddressBookService"
  import { stringHelper } from "@/components/mixins/stringHelper"
  import { sizeHelper } from "@/components/mixins/sizeHelper"
  import DnFunctionButton from "@/components/Elements/DnFunctionButton"
  import EmergencyShipToOverride from "./EmergencyShipToOverride"
  import CustomerAddressModal from "@/components/Modals/CustomerAddressModal"
  import { countryHelper } from "@/components/mixins/countryHelper"
  import { ErrorLogService } from "@/services/ErrorLogService"
  import { paginationMixin } from "@/components/mixins/paginationMixin"

  export default {
    components: {
      MyAccount,
      EmergencyShipToOverride,
      CustomerAddressModal,
      DnFunctionButton
    },
    mixins: [stringHelper, countryHelper, sizeHelper, paginationMixin],
    data: () => ({
      showModal: false,
      showDeletePrompt: false,
      wasAddOrEditButtonClicked: "",
      customerFilter: null,
      addressBookSummary: [],
      addressBookColumns: [
        { key: "CustomerName", label: "", sortable: true, formatter: "editAddress" },
        { key: "CustomerName2", label: "", sortable: true},
        { key: "AddressLine1", label: "", sortable: true },
        { key: "AddressLine2", label: "", sortable: true },
        { key: "City", label: "", sortable: true },
        { key: "StateProvince", label: "", sortable: true },
        { key: "PostalCode", label: "", sortable: true },
        { key: "Country", label: "", sortable: true },
        { key: "actions", label: "", sortable: false }
      ],
      CustomerAddressToEdit: {
        AddressId: 0,
        CustomerId: 0,
        CustomerName: "",
        CustomerName2: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        StateProvince: "",
        Country: "",
        PostalCode: ""
      },
      CustomerAddressToDelete: {
        CustomerId: 0,
        CustomerName: ""
      },
      sortBy: "CustomerName",
      sortDesc: false,
    }),
    computed: {
      ...mapGetters(["user", "getContentItem", "activeAccountId"]),
      customerAddressModalTitle () {
        if (this.wasAddOrEditButtonClicked == "add") {
          return this.getContentItem("addressBookAdd")
        }
        return this.getContentItem("editNewCustomer")
      }
    },
    created: function () {
      this.addressBookColumns[0].label = this.getContentItem("company")
      this.addressBookColumns[1].label = this.getContentItem("attn")
      this.addressBookColumns[2].label = this.getContentItem("addressLine1")
      this.addressBookColumns[3].label = this.getContentItem("addressLine2")
      this.addressBookColumns[4].label = this.getContentItem("city")
      this.addressBookColumns[5].label = this.getContentItem("state")
      this.addressBookColumns[6].label = this.getContentItem("postalcode")
      this.addressBookColumns[7].label = this.getContentItem("country")
    },
    methods: {
      getCustomers (ctx) {
        if (this.customerFilter == null) {
          this.customerFilter = ""
        }
        return AddressBookService.GetAddressBookCustomers(this.activeAccountId, this.user.UserId, this.customerFilter, this.pagination.currentPage, this.pagination.perPage, this.sortBy, this.sortDesc)
          .then(addressSummary => {
            this.pagination.totalRows = addressSummary.Total

            return addressSummary.Items

          }).catch(err => {
            ErrorLogService.LogException(err)
            return []
          })
      },
      addAddress () {
        this.editAddress({})
      },
      editAddress (item) {
        //edit class this function by passing in the row, save calls it by passing an empty item.
        if (item.AddressId) {
          this.wasAddOrEditButtonClicked = "edit"
        } else {
          this.wasAddOrEditButtonClicked = "add"
        }

        this.CustomerAddressToEdit = item
        this.showModal = true
      },
      prepDelete (item) {
        this.CustomerAddressToDelete.CustomerName = item.CustomerName;
        this.CustomerAddressToDelete.CustomerId = item.CustomerId;
        this.showDeletePrompt = true;
        window.scrollTo(0,0)
      },
      deleteAddress (customerId) {
        return AddressBookService.DeleteCustomerAddress(this.activeAccountId, this.user.UserId, customerId).then(savedResult => {
          this.$refs.customerAddressTableRef.refresh()
          this.showDeletePrompt = false;
          return savedResult
        })
          .catch(err => {
            ErrorLogService.LogException(err)
            return []
          })
      },
      saveAddress (addressDto) {
        this.wasAddOrEditButtonClicked = "add"
        
        AddressBookService.SaveCustomerAddress(this.activeAccountId, this.user.UserId, addressDto).then(savedResult => {
          // We need to toggle the "modal" display first so the customerAddressTableRef is available when we refresh it
          this.$store.commit("pushTimedMessage", {
            header: "Address saved successfully",
            IsError: false,
            seconds: 3,
          });
          this.showModal = false
          this.$refs.customerAddressTableRef?.refresh()
          return savedResult
        })
          .catch(err => {
            ErrorLogService.LogException(err)
          })
      },
      // timeout function allows this method to be called every 350ms
      ApplyFilter: function () {
        //https://stackoverflow.com/q/37587800/vue-debounce-a-method
        clearTimeout(this.timer) // if this method is called before 350ms, than the refresh will be cancelled
        this.timer = setTimeout(function () {
          this.$refs.customerAddressTableRef?.refresh()
        }.bind(this), 350)
      },
    },
  }
</script>



<style lang="scss">
.ablc{
  .nav-tabs {
    padding-bottom: 7px;
  }
}
</style>
